import { createRequest } from "helpers/tools";

export const getMetaData = async () => {
    return await createRequest({
        suffix: `dashboard/meta-data`,
        method: "get",
        handleError: false,
    });
};

export const getTrackersPdf = async () => {
    return await createRequest({
        suffix: `trackers/pdf-available-destinations`,
        method: "get",
        handleError: false,
    });
};
